import { useState } from 'react';
import { supChatbotUserUpdate } from '../../../api/supportAdmin';
import { formatPhone } from '../../../utils/formatPhoneNumber';

export default function DetailsTab({ user, getStatus, getFollowUps, setSelectedUser, updateUserData }) {
    const [showTripModal, setShowTripModal] = useState(false);

    const [tripForm, setTripForm] = useState({
        selectedCity: '',
        selectedPlace: '',
        selectedType: '',
        travellerCount: ''
    });

    const openTripModal = () => {
        setTripForm({
            selectedCity: user?.selectedCity || '',
            selectedPlace: user?.selectedPlace || '',
            selectedType: user?.selectedType || '',
            travellerCount: user?.travellerCount || ''
        });

        setShowTripModal(true);
    };

    const handleTripChange = (e) => {
        const { name, value } = e.target;

        setTripForm((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    return (
        <div className='detailsTab'>
            <div className='detailsGrid'>
                {/* USER INFORMATION */}

                <div className='detailCard'>
                    <h3>User Information</h3>

                    <div className='detailRow'>
                        <span>Name</span>
                        <strong>{user?.name || 'Anonymous'}</strong>
                    </div>

                    <div className='detailRow'>
                        <span>Phone</span>
                        <strong>{formatPhone(user?.phoneNumber) || '-'}</strong>
                    </div>

                    <div className='detailRow'>
                        <span>Platform</span>
                        <strong style={{ textTransform: 'capitalize' }}>{user?.platform}</strong>
                    </div>

                    <div className='detailRow'>
                        <span>Chat Status</span>

                        <span className='chatStatusBadgeSmall'>{user?.status}</span>
                    </div>

                    <div className='detailRow'>
                        <span>Lead Status</span>

                        <span className={`leadStatusBadge ${(user?.leadStatus || 'New').replace(/\s/g, '')}`}>
                            {user?.leadStatus || 'New'}
                        </span>
                    </div>

                    <div className='detailRow'>
                        <span>First Interaction</span>

                        <strong>{new Date(user.createdAt).toLocaleString()}</strong>
                    </div>

                    <div className='detailRow'>
                        <span>Last Interaction</span>

                        <strong>{new Date(user.lastInteractionAt).toLocaleString()}</strong>
                    </div>
                </div>

                {/* TRIP */}

                <div className='detailCard'>
                    <div className='cardHeader'>
                        <h3>Trip Preferences</h3>

                        <button className='editBtn' onClick={openTripModal}>
                            ✏️
                        </button>
                    </div>

                    <div className='detailRow'>
                        <span>Departure City</span>
                        <strong>{user?.selectedCity || '-'}</strong>
                    </div>

                    <div className='detailRow'>
                        <span>Destination</span>
                        <strong>{user?.selectedPlace || '-'}</strong>
                    </div>

                    <div className='detailRow'>
                        <span>Trip Type</span>
                        <strong>{user?.selectedType || '-'}</strong>
                    </div>

                    <div className='detailRow'>
                        <span>Travellers</span>
                        <strong>{user?.travellerCount || '-'}</strong>
                    </div>

                    <div className='detailRow'>
                        <span>Follow Ups</span>
                        <strong>{getFollowUps(user)}/5</strong>
                    </div>

                    <div className='detailRow'>
                        <span>Support Requested</span>

                        <strong>{user?.supportRequested ? 'Yes' : 'No'}</strong>
                    </div>
                </div>

                {/* PREVIOUS */}

                <div className='detailCard fullWidth'>
                    <h3>Previous Selections</h3>

                    <div className='previousGrid'>
                        <div className='previousItem'>
                            <label>City</label>
                            <p>{user?.previousSelection?.selectedCity || '-'}</p>
                        </div>

                        <div className='previousItem'>
                            <label>Destination</label>
                            <p>{user?.previousSelection?.selectedPlace || '-'}</p>
                        </div>

                        <div className='previousItem'>
                            <label>Trip Type</label>
                            <p>{user?.previousSelection?.selectedType || '-'}</p>
                        </div>

                        <div className='previousItem'>
                            <label>Travellers</label>
                            <p>{user?.previousSelection?.travellerCount || '-'}</p>
                        </div>
                    </div>
                </div>
            </div>
            {showTripModal && (
                <div className='statusModalOverlay'>
                    <div className='statusModal'>
                        <h3>Edit Trip Preferences</h3>

                        <div className='formGroup'>
                            <label>Departure City</label>

                            <input
                                type='text'
                                name='selectedCity'
                                value={tripForm.selectedCity}
                                onChange={handleTripChange}
                            />
                        </div>

                        <div className='formGroup'>
                            <label>Destination</label>

                            <input
                                type='text'
                                name='selectedPlace'
                                value={tripForm.selectedPlace}
                                onChange={handleTripChange}
                            />
                        </div>

                        <div className='formGroup'>
                            <label>Trip Type</label>

                            <input
                                type='text'
                                name='selectedType'
                                value={tripForm.selectedType}
                                onChange={handleTripChange}
                            />
                        </div>

                        <div className='formGroup'>
                            <label>Travellers</label>

                            <input
                                type='number'
                                min='1'
                                name='travellerCount'
                                value={tripForm.travellerCount}
                                onChange={handleTripChange}
                            />
                        </div>

                        <div className='statusModalFooter'>
                            <button className='secondaryBtn' onClick={() => setShowTripModal(false)}>
                                Cancel
                            </button>

                            <button
                                className='primaryBtn'
                                onClick={() => {
                                    updateUserData({ updates: tripForm });
                                    setShowTripModal(false);
                                }}
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
